let fleetName
const FleetService = {
  async getFleetName(fleet, fieldbeat) {

    if (!fleet) {
      return
    }

    fleetName = fleet
    const user = localStorage.getItem('user');
    const pass = localStorage.getItem('pass');

    if (user && pass) {
      try {
        fieldbeat.authorize_as_basic(user, pass)

        const response = await fieldbeat.get('/fleets/' + fleetName + '/workers');
        if (response.code === 200) {
          const workersData = response.entities;
          const workers = workersData.map(worker => worker.username);
          workers.sort((a, b) => {
            const nameA = a.toLowerCase();
            const nameB = b.toLowerCase();
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          });
          const phone = workersData.find(worker => worker.phone)?.phone;

          return { workers, workersData, phone };
        }
      } catch (error) {
        throw new Error('Error al obtener los trabajadores: ' + error.message);
      }
    }
  },

  async getVersion(selectedWorker, workersData) {
    localStorage.setItem('workerName', selectedWorker)
    const selectedIndex = workersData.findIndex(worker => worker.username === selectedWorker);
    if (selectedIndex !== -1) {
      const selectedWorkerData = workersData[selectedIndex];
      if (selectedWorkerData && selectedWorkerData.phone && selectedWorkerData.phone.app_version_name) {
        return selectedWorkerData.phone.app_version_name;
      }else{
        return undefined;
      }
    }
  },

  async getLogs(workerName, fieldbeat) {

    const data = {
      recipient: workerName,
      recipient_type: "WORKER",
      data: {
        type: "logs_request",
        properties: {},
      }
    }
    
    const response = fieldbeat.post('/fleets/' + fleetName + '/tools/send_firebase', data);
    return response;
  },

  async printTaskLog(workerName, fieldbeat) {

    const data = {
      recipient: workerName,
      recipient_type: "WORKER",
      data: {
        type: "log_all_tasks",
        properties: {},
      }
    }
    const response = fieldbeat.post('/fleets/' + fleetName + '/tools/send_firebase', data);
    return response;
  },

  async lastMessagesLog(workerName, fieldbeat) {

    const data = {
      recipient: workerName,
      recipient_type: "WORKER",
      data: {
        type: "log_delayed_messages",
        properties: {},
      },
    }

    const response = fieldbeat.post('/fleets/' + fleetName + '/tools/send_firebase', data);
    return response;
  },
  async disconnect(workerName, fieldbeat) {

    const data = {
      recipient: workerName,
      recipient_type: "WORKER",
      data: {
        type: "logout",
        properties: {},
      }
    }

    const response = fieldbeat.post('/fleets/' + fleetName + '/tools/send_firebase', data);
    return response;
  },
  async deleteTask(workerName, id, fieldbeat) {

    if (id > 0) {

      const data = {
        recipient: workerName,
        recipient_type: "WORKER",
        data: {
          type: "task_remove",
          properties: {
            task_id: parseInt(id)
          }
        }
      }

      const response = fieldbeat.post('/fleets/' + fleetName + '/tools/send_firebase', data);
      return response;
    }
  },
  async deleteMessage(workerName, id, fieldbeat) {
    if (id > 0) {
      const data = {
        recipient: workerName,
        recipient_type: "WORKER",
        data: {
          type: "remove_delayed_by_id",
          properties: {
            message_id: parseInt(id)
          }
        }
      }

      const response = fieldbeat.post('/fleets/' + fleetName + '/tools/send_firebase', data);
      return response;
    }
  },

  async syncTransitions(workerName, id, email, fieldbeat) {
    if (id && email) {
      const data = {
        recipient: workerName,
        recipient_type: "WORKER",
        data: {
          type: "send_transitions_done",
          properties: {
            task_id: parseInt(id),
            email: email
          }
        }
      }

      const response = fieldbeat.post('/fleets/' + fleetName + '/tools/send_firebase', data);
      return response;
    }
  },
  async sendFakeMessage(workerName, option, fakeMessage, fieldbeat) {
    if (option && fakeMessage) {
      const data = {
        recipient: workerName,
        recipient_type: "WORKER",
        data: {
          type: "send_transitions_done",
          properties: {
            type: option,
            content: fakeMessage,
          },
        }
      }

      const response = fieldbeat.post('/fleets/' + fleetName + '/tools/send_firebase', data);
      return response;
    }
  }
};

export default FleetService;
